"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyClientImpl = void 0;
const HttpClientImpl_1 = require("./HttpClientImpl");
class CurrencyClientImpl extends HttpClientImpl_1.HttpClientImpl {
    constructor(options, prefix) {
        super(options);
        this.fetch = async () => {
            return this.get(`${this.prefix}`);
        };
        this.prefix = `${prefix}/v1/currency`;
    }
}
exports.CurrencyClientImpl = CurrencyClientImpl;
